<template>
  <div id="contenedor-agregar-contrato-relacionado">
    <v-form v-model="formularioValido" ref="agregarContratoRelacionado">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Contrato Relacionado
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-autocomplete
            cols="12"
            v-model="contratoRelacionado.idContratoRelacionado"
            label="Seleccionar contrato"
            :items="getContratosAgregar"
            item-text="numero"
            item-value="id"
            clearable
            :rules="[mixReglas.requerido]">
          </custom-autocomplete>
          <v-switch
            v-model="contratoRelacionado.esSupervisionExterna"
            label="¿Es Supervision Externa?"
            inset>
          </v-switch>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarcontratoRelacionado"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratosRelacionados from './mixContratosRelacionados';

export default {
  name: 'AgregarContratoRelacionado',
  mixins: [mixContratosRelacionados],
  props: {
    contrato: {
      type: Object,
      required: true,
    },
    contratos: {
      type: Array,
      required: true,
    },
    contratosRelacionados: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomButton,
    CustomAutocomplete,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      contratoRelacionado: {
        idContrato: this.contrato.id,
        idContratoRelacionado: '',
        esSupervisionExterna: false,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.agregarContratoRelacionado.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratosAgregar() {
      // Se agregan los contratos relacionados al contrato a la lista de contratos a omitirse.
      const contratosOmitir = this.contratosRelacionados.map((contrato) => ({
        id: contrato.idContratoRelacionado,
        numero: contrato.contratoRelacionado.numero,
      }));
      // Agrego el contrato padre a la lista de contratos a omitirse.
      contratosOmitir.push({
        id: this.contrato.id,
        numero: this.contrato.numero,
      });
      const listaContratos = [];
      this.contratos
        .map((contrato) => ({
          id: contrato.id,
          numero: contrato.numero,
        }))
        .forEach((contrato) => {
          // se verifico si el contrato existe en el listado de contratos a omitir.
          const index = contratosOmitir
            .findIndex((contratoOmitir) => contratoOmitir.id === contrato.id);
          // si el contrato no existe en el listado a omitirse lo agrego al listado de contratos
          if (index === -1) {
            listaContratos.push(contrato);
          }
        });
      return listaContratos;
    },
  },
};
</script>

<style lang="scss">

</style>
